import * as R from 'ramda'
import { defaultSelectedPlaceIndex } from './accessControlService'
import { anyExist } from 'libs/ramdaExt'

// users/my
export const getSuspendedStatusFromAPI = (user) => {
  const teamMemberSuspendedReason = R.path(
    ['places', defaultSelectedPlaceIndex, 'userPlace', 'suspendedReason'],
    user,
  )

  const placeSuspendedReason = R.path(
    ['places', defaultSelectedPlaceIndex, 'info', 'suspendedReason'],
    user,
  )

  return {
    place: placeSuspendedReason,
    teamMember: teamMemberSuspendedReason,
  }
}

export const isSuspended = anyExist(['place', 'teamMember'])

export const ERROR_SUSPEND = 'ERROR_SUSPEND'
export const createSuspendError = R.compose(
  R.mergeRight({ type: ERROR_SUSPEND }),
  R.objOf('suspendStatus'),
)
export const isSuspendError = R.compose(R.equals(ERROR_SUSPEND), R.prop('type'))
export const getSuspendErrorStatus = R.prop('suspendStatus')

export const rejectOnSuspended = R.ifElse(
  R.compose(isSuspended, getSuspendedStatusFromAPI),
  R.compose(
    (error) => Promise.reject(error),
    createSuspendError,
    getSuspendedStatusFromAPI,
  ),
  (user) => Promise.resolve(user),
)
